import { useAtomValue } from 'jotai';
import React, { useEffect } from 'react';

import { Loader } from '~/components/blocks';
import {
  DirectVisitorDetailDialogProfileFragment,
  LineVisitorDetailDialogProfileFragment,
  PatientDetailDialogProfileFragment,
  WebVisitorDetailDialogProfileFragment,
} from '~/graphql/generated/graphql';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';

import { ExclusiveLockError } from './ExclusiveLockError';
import { InputPane } from './InputPane';
import { useExclusiveLock } from './use-exclusive_lock';

type Props = {
  patient?:
    | DirectVisitorDetailDialogProfileFragment
    | WebVisitorDetailDialogProfileFragment
    | PatientDetailDialogProfileFragment
    | LineVisitorDetailDialogProfileFragment;
};

export const NewTracingReportPane = (props: Props) => {
  const { isOpen, patientId, type } = useAtomValue(patientDetailDialogState);
  const { patient } = props;

  const {
    lock,
    unlock,
    status: exclusiveLockStatus,
    error: exclusiveLockError,
    setError: setExclusiveLockError,
  } = useExclusiveLock({
    patientId: patient?.medixsPatient?.id || patientId,
  });

  useEffect(() => {
    if (isOpen && patientId) {
      lock();
    }
    return () => {
      setExclusiveLockError(null);
      if (exclusiveLockStatus === 'locking') {
        unlock();
      }
    };
  }, [exclusiveLockStatus, isOpen, lock, patientId, unlock, setExclusiveLockError]);

  return (
    <>
      {type === 'tracingreport' &&
        (!exclusiveLockError ? (
          <Loader open inside />
        ) : exclusiveLockStatus === 'locking' ? (
          <InputPane patientType={patient?.__typename} />
        ) : (
          exclusiveLockError && <ExclusiveLockError error={exclusiveLockError} />
        ))}
    </>
  );
};
